<template>
  <ClientOnly>
    <BModal
      v-if="show"
      v-model="show"
      no-footer
      lazy
    >
      <p>{{ t('invitationCodeModalIntro') }}</p>
      <InvitationCodeActivation
      :button-text="t('Activate')" />
    </BModal>
  </ClientOnly>
</template>

<script setup lang="ts">
import InvitationCodeActivation from '~/components/invitation_code/InvitationCodeActivation.vue';
const { t } = useI18n();
const show = ref(false);
const showModal = () => {
    show.value = true;
}

defineExpose({
    showModal,
})
</script>

<i18n lang="json">
{
    "en": {
        "invitationCodeModalIntro": "An invitation code is a personal code issued by fair participants. If you've received one, enter it here. If not, you can skip this step."
    },
    "ru": {
        "Activate Invitation Code": "Активировать код приглашения",
        "Activate": "Активировать",
        "invitationCodeModalIntro": "Код приглашения — персональный код, который выдают участники ярмарки. Если вы получили такой код, введите его здесь. Если нет — этот шаг можно пропустить."
    }
}
</i18n>
